// eslint-disable-next-line import/prefer-default-export
export const GetProgramInnovationSelector = ({
  programInnovation: { GetProgramInnovation }
}) => GetProgramInnovation;

export const PostProgramInnovationSelector = ({
  programInnovation: { PostProgramInnovation }
}) => PostProgramInnovation;
